import store from 'store';

const MUTATION_PATTERN = /\b(save|edit|delete|add|upload|update|send)\b/i;
const MUTATION_ICON_PATTERN = /(save|pencil|edit|trash|delete|plus|add|upload|update|send|paper-plane|envelope)/i;
const MUTATION_PATH_PATTERN = /(save|edit|delete|add|upload|update|send)/i;
const JOB_ACTIONS_PATTERN = /\bjob\s*actions\b/i;
const SEARCH_PATTERN = /\b(search|filter)\b/i;
const SEARCH_ICON_PATTERN = /(filter|search)/i;
const SEARCH_HINT_PATTERN = /\b(search|filter|match|criteria|keyword)\b/i;

const getTextFromChildren = (children) => {
    if (children === null || children === undefined) {
        return '';
    }

    if (typeof children === 'string' || typeof children === 'number') {
        return String(children);
    }

    if (Array.isArray(children)) {
        return children.map(getTextFromChildren).join(' ');
    }

    if (children.props && children.props.children) {
        return getTextFromChildren(children.props.children);
    }

    return '';
};

const isFacilityReadOnly = () => {
    const facility = store.get('currentFacility');
    if (facility && typeof facility.isReadOnly === 'boolean') {
        return facility.isReadOnly;
    }

    const loginInfo = store.get('InteServLoginInfo');
    return !!(loginInfo && loginInfo.isReadOnly);
};

const hasMutationIntent = (props) => {
    const id = props.id || '';
    const name = props.name || '';
    const title = props.title || '';
    const icon = props.icon || '';
    const to = props.to || '';
    const childrenText = getTextFromChildren(props.children);

    return MUTATION_PATTERN.test(id)
        || MUTATION_PATTERN.test(name)
        || MUTATION_PATTERN.test(title)
        || MUTATION_PATTERN.test(childrenText)
        || MUTATION_ICON_PATTERN.test(icon)
        || MUTATION_PATH_PATTERN.test(to);
};

    const hasJobActionsIntent = (props = {}) => {
        const id = props.id || '';
        const name = props.name || '';
        const title = props.title || '';
        const childrenText = getTextFromChildren(props.children);

        return JOB_ACTIONS_PATTERN.test(id)
        || JOB_ACTIONS_PATTERN.test(name)
        || JOB_ACTIONS_PATTERN.test(title)
        || JOB_ACTIONS_PATTERN.test(childrenText);
    };

const hasSearchIntent = (props = {}) => {
    const id = props.id || '';
    const name = props.name || '';
    const title = props.title || '';
    const label = props.label || '';
    const hint = props.hint || '';
    const placeholder = props.placeholder || '';
    const prependLabelIcon = props.prependLabelIcon || '';
    const childrenText = getTextFromChildren(props.children);
    const type = props.type || '';

    return type === 'search'
        || SEARCH_PATTERN.test(id)
        || SEARCH_PATTERN.test(name)
        || SEARCH_PATTERN.test(title)
        || SEARCH_PATTERN.test(label)
        || SEARCH_HINT_PATTERN.test(hint)
        || SEARCH_PATTERN.test(placeholder)
        || SEARCH_PATTERN.test(childrenText)
        || SEARCH_ICON_PATTERN.test(prependLabelIcon);
};

const shouldLockField = (props = {}) => {
    if (props.ignoreFacilityReadOnly) {
        return false;
    }

    return isFacilityReadOnly() && !hasSearchIntent(props);
};

const shouldDisableMutationControl = (props) => {
    if (props && props.ignoreFacilityReadOnly) {
        return false;
    }

    return isFacilityReadOnly() && (hasMutationIntent(props) || hasJobActionsIntent(props));
};

export default {
    isFacilityReadOnly,
    hasSearchIntent,
    hasMutationIntent,
    hasJobActionsIntent,
    shouldLockField,
    shouldDisableMutationControl
};